/* global axios */
import ApiClient from './ApiClient';

class AgentBotsAPI extends ApiClient {
  constructor() {
    super('agent_bots', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  deleteAgentBotAvatar(botId) {
    return axios.delete(`${this.url}/${botId}/avatar`);
  }

  resetAccessToken(botId) {
    return axios.post(`${this.url}/${botId}/reset_access_token`);
  }

  resetSecret(botId) {
    return axios.post(`${this.url}/${botId}/reset_secret`);
  }

  // `outgoingUrl` es opcional: permite probar la URL que el admin tiene tipeada en el form
  // ANTES de guardarla, en vez de la que ya está persistida en el bot.
  testConnection(botId, outgoingUrl) {
    return axios.post(`${this.url}/${botId}/test_connection`, {
      outgoing_url: outgoingUrl,
    });
  }
}

export default new AgentBotsAPI();
